import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSticker: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sticker, badge"><path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C12.2462 2 12.4904 2.00891 12.7324 2.02644C13.1533 2.05694 13.529 2.247 13.8064 2.52439L21.4756 10.1936C21.753 10.471 21.9431 10.8467 21.9736 11.2676C21.9911 11.5096 22 11.7538 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM20.5 11.4506C16.0039 11.9923 12.0078 7.99591 12.5494 3.5L20.5 11.4506Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSticker;
